/* =========================================================
   VFW Collection page — client-side facet filter (2026-07-24)
   Any number of single-select facet groups (Platform / Build
   style / Finish). A card shows when it matches the active
   value in EVERY group (AND across groups; "All" clears a
   group). No reload; keyboard-accessible; deep-linkable
   (?platform=corvette&style=lowrider…). No JS: every card is
   visible and links to its product page (progressive
   enhancement).
   ========================================================= */

(() => {
  if (customElements.get('vfw-wheel-browser')) return;

  class VfwWheelBrowser extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('[data-facet-group]'));
      this.items = Array.from(this.querySelectorAll('.vfw-wb__item'));
      this.empty = this.querySelector('[data-wb-empty]');
      if (!this.items.length) return;

      this.groups = [...new Set(this.chips.map((c) => c.dataset.facetGroup))];
      this.selected = {};
      this.groups.forEach((g) => {
        this.selected[g] = 'all';
      });

      this.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-facet-group]');
        if (!chip || !this.contains(chip)) return;
        this.select(chip.dataset.facetGroup, chip.dataset.facetValue);
        this.syncUrl();
      });

      // Deep link: honour ?group=value for any facet group.
      const params = new URLSearchParams(window.location.search);
      let deep = false;
      this.groups.forEach((g) => {
        const v = params.get(g);
        if (v && this.chips.some((c) => c.dataset.facetGroup === g && c.dataset.facetValue === v)) {
          this.select(g, v, true);
          deep = true;
        }
      });
      if (deep) this.apply();
    }

    // Set a group's active chip; re-filter unless told to defer.
    select(group, value, defer) {
      this.selected[group] = value;
      this.chips.forEach((c) => {
        if (c.dataset.facetGroup !== group) return;
        const on = c.dataset.facetValue === value;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (!defer) this.apply();
    }

    apply() {
      let shown = 0;
      this.items.forEach((item) => {
        const match = this.groups.every((g) => {
          const sel = this.selected[g];
          if (sel === 'all') return true;
          const vals = (item.dataset[g] || '').split(/\s+/).filter(Boolean);
          return vals.includes(sel);
        });
        item.classList.toggle('is-hidden', !match);
        if (match) shown += 1;
      });
      if (this.empty) this.empty.hidden = shown !== 0;
    }

    syncUrl() {
      if (!window.history || !window.history.replaceState) return;
      const u = new URL(window.location.href);
      this.groups.forEach((g) => {
        if (this.selected[g] && this.selected[g] !== 'all') u.searchParams.set(g, this.selected[g]);
        else u.searchParams.delete(g);
      });
      window.history.replaceState(null, '', u);
    }
  }

  customElements.define('vfw-wheel-browser', VfwWheelBrowser);
})();
